module.exports = __webpack_public_path__ + "static/media/Construction.dfe430b0.mp3";